




























































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import * as qs from 'qs'
import config from '../../config'
import * as _ from 'underscore'
import Cookies from 'js-cookie'
import loginAndRegistration from './login/login.vue'
import { isWeixin } from '@ivy/fts/utils'
import * as utils from '@ivy/fts/utils'
import { isZfb, getQrcodeRoute } from './util'
import { requireGet, requirePost, addStatistics } from './require'
import { env } from '@ivy/fts/envInfo/envInfo'
import Address from './address.vue'
import orderGiftList from './orderGiftList.vue'
import disCountList from './disCountList.vue'

const convert = function(data) {
  if (typeof data !== 'object' || !data) return data
  if (Array.isArray(data)) {
    return data.map(item => convert(item))
  }

  let newObj = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      let newKey = key.replace(/_([a-z])/g, res => res[1].toUpperCase())
      newObj[newKey] = convert(data[key])
    }
  }
  return newObj
}

@Component({
  components: { loginAndRegistration, Address, orderGiftList, disCountList },
})
export default class OrderConFirm extends Vue {
  @Prop() orderParams: any
  order_data: any
  userInfo: any = {}
  show: boolean = false
  showGiftList = false
  showDiscountList = false
  products: any[] = []
  gift_list = []
  spuId: any
  skuId: any
  actId: any
  type: any
  payType: string = 'wechat' // 当前支付方式
  zfbPay: string = '' // 当前H5在支付宝环境下时跳转支付地址
  need_receiver: boolean = false
  showMore: boolean = false
  moreFlag: boolean = false
  userTelephone: string = ''
  loginInfo: any
  hasLogin: boolean = false
  channelId: any
  order: any
  discountInfo: any = ''
  tid: string = ''
  putPlat: string = ''
  xmly_materialId
  courseStartTime: string = ''
  touTiaoLink: string = ''
  discounts = []
  goodsArr = []
  coupon_id = null
  //当前选择的优惠券
  nowChooseCoupon = null
  receiver_info = null
  //可以使用的优惠券
  active_coupon = []
  //不可使用的优惠券
  dis_coupon = []
  //收货地址id
  receiver_id = null
  canClick = true
  get productsPrice() {
    return this.products.reduce((sum, cur) => {
      return cur.goods_type === 'goods_gift'
        ? sum
        : (sum += parseFloat(cur.salePrice))
    }, 0)
  }
  get priceArr() {
    if (!this.products.length) {
      return []
    }
    let arr = this.products[0].salePrice.split('.')
    // arr[1] = +this.products[0].salePrice % 1 < 0.1 ? arr[1] : arr[1][0]
    return arr
  }
  get activityImg() {
    if (this.products[0].activity_type === 'vip_price') {
      return require('./imgs/tip_vip.png')
    }
    return ''
  }
  async created() {
    this.putPlat = utils.cacheGet('putPlat') || 'gdt_vid'
    this.touTiaoLink = utils.cacheGet('link')

    const queryParam = this.$route.query // 通过页面跳转进来取路由参数
    const orderParam = this.orderParams
    let {
      type,
      skuId,
      spuId,
      actId,
      channelId,
      xmly_materialId,
      receiver_id,
      user_price,
    } = orderParam
    this.channelId = channelId
    this.spuId = spuId
    this.skuId = skuId
    this.actId = +actId
    this.type = type
    this.receiver_id = queryParam.receiver_id
    this.xmly_materialId = xmly_materialId || queryParam.xmly_materialId
    try {
      addStatistics({
        activity_id: this.actId,
        event_type: 'Click_PackagingTools_SelectSku',
        p1: this.skuId,
        p2: this.actId,
      })
    } catch {}
    await this.getClassStartTime()
    await this.verifyLogin()
    this.goodsArr.push({
      id: this.skuId,
      type: this.type,
      is_group: 0,
      user_price: user_price,
    })
    await this.getSpuInfo()

    this.show = true
  }
  updateCouponInfo(coupon) {
    this.nowChooseCoupon = coupon
    this.coupon_id = this.nowChooseCoupon && this.nowChooseCoupon.id
  }
  get payImg() {
    if (this.payType === 'wechat') {
      return require('./imgs/icon_weixin.png')
    } else if (this.payType === 'alipay') {
      return require('./imgs/icon_weixin.png')
    }
    return ''
  }
  //首次获取商品信息
  async getSpuInfo() {
    let { data } = await this.$axios.post(
      `/api/goods/v1/order/getOrderConfirmInfo`,
      {
        goods: this.goodsArr,
        coupon_id: this.coupon_id,
        receiver_id: this.receiver_id,
        channel_id: this.channelId,
      },
      {
        disableAlert: true,
      }
    )
    if (data.code === 20001) {
      this.$Toast(data.message)
      return this.clickClose(true)
    }
    if (data.tips) {
      this.$Toast(data.tips)
    }
    this.order_data = data
    //优惠券
    this.discounts = data.coupons
    this.active_coupon = (this.discounts || []).filter(
      item => +item.is_disabled === 0
    )
    this.dis_coupon = (this.discounts || []).filter(
      item => +item.is_disabled === 1
    )
    this.products = data.skus
    //赠品
    this.gift_list = this.products[0].gifts
    this.need_receiver = !!data.need_receiver
    this.receiver_info = data.receiver_info
    this.receiver_id = data.receiver_id
    if (
      this.active_coupon &&
      this.active_coupon.length &&
      this.order_data.selected_coupon_id
    ) {
      let select = this.active_coupon.filter(
        item => +item.id === +this.order_data.selected_coupon_id
      )
      if (select) {
        this.updateCouponInfo(select[0])
      }
    }
    this.payType = await this.getPayType()
  }

  chooseCoupon(coupon_id) {
    //先记录先前的优惠券id
    let curCop = this.coupon_id
    if (coupon_id) {
      this.updateCouponInfo(this.discounts.find(v => v.id === coupon_id))
    } else {
      this.nowChooseCoupon = null
      this.coupon_id = null
    }
    //优惠券发生变化后重新算价
    if (this.active_coupon && this.active_coupon.length) {
      if (!this.coupon_id) {
        this.coupon_id = 0
      }
      if (curCop != this.coupon_id) {
        this.getSpuInfo()
      }
    }
    this.clickReturn()
  }
  clickClose(noShow = false) {
    this.$emit('clickClose', noShow)
  }
  clickMore() {
    this.showMore = !this.showMore
    if (this.moreFlag) {
      setTimeout(() => {
        this.moreFlag = !this.moreFlag
      }, 500)
    } else {
      this.moreFlag = !this.moreFlag
    }
  }
  clickReturn() {
    this.showGiftList = false
    this.showDiscountList = false
    this.show = true
  }
  clickDiscount() {
    this.showDiscountList = true
    this.show = false
  }
  //点击赠品列表
  clickGift() {
    if (!this.gift_list || !this.gift_list.length) return
    this.show = false
    this.showGiftList = true
  }
  async verifyLogin() {
    await env.init()
    if (env.type === 'web') return this.$Toast('请在微信中打开')
    if (!(await env.getIsLogin())) {
      return await env.login()
    }

    let userInfo = await env.getInfo()
    this.userInfo = userInfo
    let token =
      env.type === 'wx' ? userInfo.logined.token : userInfo.publicParams.token
    this.userTelephone =
      env.type === 'wx'
        ? userInfo.logined.user.user_telephone
        : userInfo.extraData.phoneNumber
    // this.loginInfo = userInfo.logined
    if (!token) {
      // 用户尚未注册
      this.hasLogin = false
      this.$Toast('输入上课手机号并且验证成功即可享受课程哦~')
    } else {
      this.hasLogin = true
    }
  }
  async getRegisterBySku() {
    const { data: registerData } = await requireGet(
      `/api/m-course/crm/getRegisterBySku?sku_id=${this.skuId}`
    )
    if (registerData.tid) {
      window.location.replace(
        `${
          window.location.origin
        }/act2/invitationMarket/loadingView?${qs.stringify({
          tid: registerData.tid,
          channel_id: this.channelId,
        })}`
      )
    }
  }
  async getPayType() {
    let _info = this.products[0] || {}
    let { data } = await this.$axios.post(
      '/api/goods/order/order/getPayTypeList',
      {
        skus: [
          {
            id: _info.id,
            type: _info.type,
            isTrueGroup: false,
          },
        ],
        pay_scene: 1,
      }
    )
    if (data && data.length) {
      return data[0].pay_type
    }
    return 'wechat'
  }

  async onPayByApp() {
    // 获取支付方式
    let payType = await this.getPayType()
    await env.init(null, null, this.paySuccess)

    let _info = this.products[0] || {}
    await env.pay({
      type: _info.type,
      productType: _info.type,
      payType: payType,
      productId: _info.id,
      addressId: Number(this.receiver_id),
      activity: this.coupon_id ? { coupon: this.coupon_id } : null,
    })

    return
  }
  async onPay() {
    if (!this.canClick) return
    try {
      await addStatistics({
        activity_id: this.$route.query.act_id,
        event_type: 'Click_PackagingTools_Buy',
        p1: this.products[0].id,
        p2: this.$route.query.act_id,
      })
    } catch {}
    await utils.sleep(500)
    if (this.hasLogin === false) {
      return this.$Toast('填写上课手机号并通过验证后即可享受课程哦~')
    }
    if (env.type === 'ivydad') {
      return this.onPayByApp()
    }

    await this.submitOrder()
    this.canClick = true
    if (!this.tid) return // 调完submit没有返回tid，则中断后续操作
    // 添加下单短信埋点，使后续可以收到短信通知
    await requirePost(
      '/api/activity/crm/put/addSubscribeSmsMsg',
      {
        openid:
          env.type === 'wx'
            ? this.userInfo.logined.openid
            : this.userInfo.openId,
        tid: this.tid,
        channel_id: this.channelId,
        act_id: this.actId,
        is_from_h5: 1,
      },
      {
        disableAlert: true,
      }
    )
    // 埋点-购课成功
    let {
      posterId,
      _sessionStorageInviteActivityId: activityId,
      source,
      labelId,
    } = this.$route.query
    const distributorMemId =
      sessionStorage.getItem('_sessionStorageDistributorMemId') ||
      sessionStorage.getItem('_cookieDistributorMemId')
    let userInfo: any = {}
    if (distributorMemId) {
      userInfo = await requireGet(
        `/api/activity/h5Activity/invitation/checkUserType?distributorMemId=${distributorMemId}`
      )
    }
    let sourceName = source
    if (labelId) {
      let { data: info } = await requireGet(
        `/api/activity/h5Activity/invitation/getLabelTagName?labelId=${labelId}`
      )
      sourceName = info
    }
    if (this.$route.query._lottery) {
      // 来自大转盘购课成功埋点
      await addStatistics(
        {
          activity_id: this.$route.query._sessionStorageInviteActivityId,
          event_type: 'Inviteduser_Success_class_zjs',
          p1: this.$route.query.labelId || this.$route.query.from,
          p2: (await requireGet(
            `/api/activity/h5Activity/invitation/checkUserType`
          )).data,
          p5: distributorMemId,
        },
        !!this.$route.query.labelId
      )
    } else if (distributorMemId) {
      await addStatistics({
        activity_id: activityId,
        event_type: 'Inviteduser_Success_class_zjs',
        p1: sourceName,
        p2: userInfo.data,
        p4: posterId,
        p5: distributorMemId,
      })
    }
    const { _redirect, payUrl, pay } = this.getPayDoneRedirct()
    if (+this.order.total_fee < 0.01) {
      // 0元商品跳过支付环节
      return (window.location.href = _redirect)
    }
    window.location.href = isZfb() ? this.zfbPay : payUrl
  }
  paySuccess(config) {
    this.$router.push({
      path: 'appPayResult',
      query: {
        tid: config,
      },
    })
  }
  getPayDoneRedirct() {
    let _redirect = `${
      window.location.origin
    }/act2/invitationMarket/loadingView?${qs.stringify({
      tid: this.tid,
      channel_id: this.channelId,
      ...this.order,
    })}`
    const orderPage = window.location.href
    const cancelUrl = orderPage.includes('putGoodsPop')
      ? utils.cacheGet('goodsPopUrl')
      : orderPage
    utils.cacheSet('redirect', _redirect)
    utils.cacheSet('cancelUrl', cancelUrl)
    const verifyPayResultUrl = `${
      window.location.origin
    }/act2/invitationMarket/verifyPayResult?tid=${
      this.tid
    }&url=${encodeURIComponent(_redirect)}&cancelUrl=${encodeURIComponent(
      cancelUrl
    )}`
    let host =
      config.env === 'production' ? window.location.host : 'm.ivydad.com.cn'
    if (host.indexOf('simulate') >= 0) host = 'm.ivydad.com'
    const payUrl = isWeixin()
      ? `//${host}/pay/?${qs.stringify({
          pay: { ...this.order },
          redirect: _redirect,
        })}`
      : `${this.order.mweb_url}&redirect_url=${encodeURIComponent(
          verifyPayResultUrl
        )}`
    return { _redirect, payUrl, pay: this.order }
  }
  async submitOrder() {
    this.canClick = false
    setTimeout(() => {
      this.canClick = true
    }, 2000)
    const redirect_url =
      isZfb() &&
      `${window.location.origin}/act2/invitationMarket/verifyPayResult`
    const globalParam = {
      distributorMemId:
        sessionStorage.getItem('_sessionStorageDistributorMemId') ||
        sessionStorage.getItem('_cookieDistributorMemId'),
      appName:
        sessionStorage.getItem('_sessionStorageAppName') ||
        Cookies.get('_cookieAppName'),
      channel_id: this.channelId,
      invite_activity_id:
        this.$route.query._sessionStorageInviteActivityId ||
        sessionStorage.getItem('_sessionStorageInviteActivityId'),
    }
    let order: any = {
      pay_type: this.payType,
      type: 'normal',
      ignore_gift: 1,
      coupon_user_ids: this.coupon_id ? [this.coupon_id] : null,
      skus: [
        {
          id: this.skuId,
          type: this.type,
          num: 1,
        },
      ],
    }

    if (isZfb()) {
      order = { ...order, appid: '2021001187673729', redirect_url } // 调支付宝支付必传 appid 和 redirect_url
    } else if (!isWeixin()) {
      order = { ...order, trade_type: 'MWEB' }
    }
    let pay = await requirePost(
      `/api/goods/order/order/popSubmit`,
      {
        ...order,
        ...globalParam,
        receiver_id: this.receiver_id,
      },
      {
        disableAlert: true,
      }
    )
    if (pay.data.message) {
      this.$Toast(pay.data.message)
      await utils.sleep(1000)
      return await this.getRegisterBySku()
    }
    this.order = pay.data
    this.tid = this.order.tid
    this.zfbPay = this.order.pay_url
  }
  async getClassStartTime() {
    // 获取课程开课时间
    const { data: courseStartTime } = await requireGet(
      `/api/goods/shop/search/goods/getCourseStartTimeBySkuId?skuId=${
        this.skuId
      }`
    )
    this.courseStartTime = courseStartTime
  }
  padStart(str: string, long: number, padStr: string) {
    if (str.length < long) {
      for (let index = 0; index < long - str.length; index++) {
        str = padStr + str
      }
    }
    return str
  }
}
